import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { QuizQuestionType } from "@/models/quiz.model";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
import QuizCheckableTextQuestion from "@/components/quiz/QuizCheckableTextQuestion.vue";
import QuizSimpleTextQuestion from "@/components/quiz/QuizSimpleTextQuestion.vue";
import QuizBlanksQuestion from "@/components/quiz/QuizBlanksQuestion.vue";
import QuizUtils from "@/util/quizUtils";
import QuizPairsMatchingQuestion from "@/components/quiz/QuizPairsMatchingQuestion.vue";
import QuizSortingQuestion from "@/components/quiz/QuizSortingQuestion.vue";
let ExamQuiz = class ExamQuiz extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "question", null);
    _defineProperty(this, "quizNbQuestions", 0);
    _defineProperty(this, "realtimeUserAnswers", null);
  }
  mounted() {
    if (this.question) {
      this.realtimeUserAnswers = this.initRealtimeUserAnswers();
    }
  }
  initRealtimeUserAnswers() {
    if (this.question) {
      return {
        questionId: this.question.id,
        questionType: this.question.type,
        order: this.question.order,
        blanksText: this.question.blanksText,
        responsesIds: [],
        responseContent: '',
        blanksResponses: [],
        pairsMatching: [],
        itemsSorting: []
      };
    }
    return null;
  }
  get userAnswers() {
    return question => {
      if (!this.realtimeUserAnswers) {
        return null;
      }
      const answersIds = this.realtimeUserAnswers?.responsesIds || [];
      if (question.type === QuizQuestionType.QUESTION_CHOIX_MULTIPLE) {
        return answersIds;
      }
      return answersIds[0] || null;
    };
  }
  get userBlanksAnswers() {
    return this.realtimeUserAnswers?.blanksResponses || [];
  }
  get userPairsMatching() {
    return this.realtimeUserAnswers?.pairsMatching || [];
  }
  get userItemsSorting() {
    return this.realtimeUserAnswers?.itemsSorting || [];
  }
  getQuestionLabel(question) {
    return `${question.order}/${this.quizNbQuestions} - ${question.label}`;
  }
  isCheckableQuestion(question) {
    return QuizUtils.isCheckableQuestion(question.type);
  }
  isBlanksQuestion(question) {
    return QuizUtils.isBlanksQuestion(question.type);
  }
  isPairsMatchingQuestion(question) {
    return QuizUtils.isPairsMatchingQuestion(question.type);
  }
  isSortingQuestion(question) {
    return QuizUtils.isSortingQuestion(question.type);
  }
  onSelectionChange(selected) {
    if (this.realtimeUserAnswers) {
      this.realtimeUserAnswers.responsesIds = Array.isArray(selected) ? selected : [selected];
    }
    this.emitQuizAnswers();
  }
  onBlankAnswerUpdate(userBlanksAnswers) {
    if (this.realtimeUserAnswers) {
      this.realtimeUserAnswers.blanksResponses = userBlanksAnswers;
      this.emitQuizAnswers();
    }
  }
  onPairMatchingUpdate(pairsMatching) {
    if (this.realtimeUserAnswers) {
      this.realtimeUserAnswers.pairsMatching = pairsMatching;
      this.emitQuizAnswers();
    }
  }
  onItemsSortingUpdate(itemsSorting) {
    if (this.realtimeUserAnswers) {
      this.realtimeUserAnswers.itemsSorting = itemsSorting;
      this.emitQuizAnswers();
    }
  }
  emitQuizAnswers() {
    return this.realtimeUserAnswers;
  }
};
__decorate([Prop({
  required: true
})], ExamQuiz.prototype, "question", void 0);
__decorate([Prop({
  required: true
})], ExamQuiz.prototype, "quizNbQuestions", void 0);
__decorate([Emit('answerChange')], ExamQuiz.prototype, "emitQuizAnswers", null);
ExamQuiz = __decorate([Component({
  components: {
    QuizSortingQuestion,
    QuizPairsMatchingQuestion,
    QuizBlanksQuestion,
    QuizSimpleTextQuestion,
    QuizCheckableTextQuestion,
    QuizReadonlyAlert,
    WInput,
    StandardButton
  }
})], ExamQuiz);
export default ExamQuiz;